import React from 'react';
import { createCommand, Option } from '@commander-js/extra-typings';
import type { CommandServices } from '@wix/cli-command-contract';
import { createI18nT } from '../i18n.js';

export const previewCommand = (
  services: CommandServices,
  cliVersion: string
) => {
  const t = createI18nT();

  return createCommand('preview')
    .description(t('site_preview_command_def.description'))
    .addOption(
      new Option(
        '--source <local|remote>',
        t('site_preview_command_def.option.source')
      ).choices(['local', 'remote'] as const)
    )
    .action(async (options, command) => {
      const { renderCommand } = await import('./render-command.js');
      const { PreviewCommand } = await import('../preview/PreviewCommand.js');

      await renderCommand(
        command,
        services,
        cliVersion,
        <PreviewCommand {...options} />
      );
    });
};
